import { keyPositionRequestFormData } from "../KeyPositionRequestForm.data";

export const setFieldParameter = (api, form, authData) => {
  return {
    ...form,

    accountInfo: {
      ...form.accountInfo,
      initialState: {
        ...form.accountInfo.initialState,
        companyName: api?.companyName || null,
        companyRegNumber: api?.companyUEN || null,
        membershipType: api?.membershipTypeName || null,
        joinedDate: api?.joinedDate || null,
        subscriptionStartDate: api?.subscriptionStartDate || null,
        subscriptionEndDate: api?.subscriptionEndDate || null,
      },
    },

    positionInfo: {
      ...form.positionInfo,

      formFields: form.positionInfo.formFields.map(f =>
        f.id === "currentTitle"
          ? {
            ...f,
            fieldSetting: {
              ...f.fieldSetting,
              formTitle: api?.corporateRoleName,
            },
          }
          : f
      ),

      initialState: {
        ...form.positionInfo.initialState,

        salutationId: api?.salutationId || null,
        currentFirstName: api?.firstName || null,
        currentLastName: api?.lastName || null,
        currentDesignation: api?.designation || null,
        currentEmail: api?.email || null,
        currentJobLevel: api?.jobLevelId || null,
        currentJobFunction: api?.jobFunctionId || null,
        contactNumberCountryId: api?.contactNumberCountryId || null,
        mobileNumberCountryId: api?.mobileNumberCountryId || null,
        // currentMobile: api?.contactNumber || null,
        // currentTelephone: api?.mobileNumber || null,
        currentMobile: api?.mobileNumber || null,
        currentTelephone: api?.contactNumber || null,
        // new
        newSalutationId: api?.newSalutationId || null,
        newFirstName: api?.newFirstName || null,
        newLastName: api?.newLastName || null,
        newDesignation: api?.newDesignation || null,
        newEmail: api?.newEmail || null,
        newJobLevel: api?.newJobLevelId || null,
        newJobFunction: api?.newJobFunctionId || null,
        newContactNumberCountryId: api?.newContactNumberCountryId || null,
        newMobileNumberCountryId: api?.newMobileNumberCountryId || null,
        // newMobile: api?.newContactNumber || null,
        // newTelephone: api?.newMobileNumber || null,
        newMobile: api?.newMobileNumber || null,
        newTelephone: api?.newContactNumber || null,
        approvalDate: api?.approvalDate || new Date(),
        approvalBy: api?.changeKeyStatusId === 18 ? authData?.userName : api?.approvalBy ?? null
      },
    },

  };
};

export const AfterApprovalsetFieldParameter = (api, form, authData) => {
  return {
    ...form,

    accountInfo: {
      ...form.accountInfo,
      initialState: {
        ...form.accountInfo.initialState,
        companyName: api?.companyName || null,
        companyRegNumber: api?.companyUEN || null,
        membershipType: api?.membershipTypeName || null,
        joinedDate: api?.joinedDate || null,
        subscriptionStartDate: api?.subscriptionStartDate || null,
        subscriptionEndDate: api?.subscriptionEndDate || null,
      },
    },

    positionInfo: {
      ...form.positionInfo,

      formFields: form.positionInfo.formFields.map(f =>
        f.id === "currentTitle"
          ? {
            ...f,
            fieldSetting: {
              ...f.fieldSetting,
              formTitle: api?.corporateRoleName,
            },
          }
          : f
      ),

      initialState: {
        ...form.positionInfo.initialState,

        salutationId: api?.newSalutationId || null,
        currentFirstName: api?.newFirstName || null,
        currentLastName: api?.newLastName || null,
        currentDesignation: api?.newDesignation || null,
        currentEmail: api?.newEmail || null,
        currentJobLevel: api?.newJobLevelId || null,
        currentJobFunction: api?.newJobFunctionId || null,
        contactNumberCountryId: api?.newContactNumberCountryId || null,
        mobileNumberCountryId: api?.newMobileNumberCountryId || null,
        currentMobile: api?.newMobileNumber || null,
        currentTelephone: api?.newContactNumber || null,
        // new
        newSalutationId: api?.salutationId || null,
        newFirstName: api?.firstName || null,
        newLastName: api?.lastName || null,
        newDesignation: api?.designation || null,
        newEmail: api?.email || null,
        newJobLevel: api?.jobLevelId || null,
        newJobFunction: api?.jobFunctionId || null,
        newContactNumberCountryId: api?.contactNumberCountryId || null,
        newMobileNumberCountryId: api?.mobileNumberCountryId || null,
        newMobile: api?.mobileNumber || null,
        newTelephone: api?.contactNumber || null,
        approvalDate: api?.approvalDate || new Date(),
        approvalBy: api?.changeKeyStatusId === 18 ? authData?.userName : api?.approvalBy ?? null
      },
    },

  };
};
export const setNewDataHideForDeleteRole = (form, authData) => {
  return {
    ...form,
    positionInfo: {
      ...form.positionInfo,
      formFields: form.positionInfo.formFields.map(field => {
        // If field id starts with "new", hide it
        if (field.id?.startsWith("new")) {
          return {
            ...field,
            style: {
              ...field.style,
              containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3 d-none",
            },
          };
        }
        // Otherwise, keep it as is
        return field;
      }),
      initialState: {
        ...form.positionInfo.initialState,
        approvalDate: new Date(),

      }
    },
  };
};

export const setFieldParameterNew = (api, form, authData) => {
  return {
    ...form,

    accountInfo: {
      ...form.accountInfo,
      initialState: {
        ...form.accountInfo.initialState,
        companyName: api?.companyName || null,
        companyRegNumber: api?.companyUEN || null,
        membershipType: api?.membershipTypeName || null,
        joinedDate: api?.joinedDate || null,
        subscriptionStartDate: api?.subscriptionStartDate || null,
        subscriptionEndDate: api?.subscriptionEndDate || null,
      },
    },

    positionInfo: {
      ...form.positionInfo,

      formFields: form.positionInfo.formFields.map(f =>
        f.id === "currentTitle"
          ? {
            ...f,
            fieldSetting: {
              ...f.fieldSetting,
              formTitle: api?.corporateRoleName,
            },
          }
          : f
      ),

      initialState: {
        ...form.positionInfo.initialState,

        salutationId: api?.salutationId || null,
        currentFirstName: api?.firstName || null,
        currentLastName: api?.lastName || null,
        currentDesignation: api?.designation || null,
        currentEmail: api?.email || null,
        currentJobLevel: api?.jobLevelId || null,
        currentJobFunction: api?.jobFunctionId || null,
        contactNumberCountryId: api?.contactNumberCountryId || null,
        mobileNumberCountryId: api?.mobileNumberCountryId || null,
        // currentMobile: api?.contactNumber || null,
        // currentTelephone: api?.mobileNumber || null,
        currentMobile: api?.mobileNumber || null,
        currentTelephone: api?.contactNumber || null,
        approvalDate: api?.approvalDate || new Date(),
        approvalBy: api?.changeKeyStatusId === 18 ? authData?.userName : api?.approvalBy ?? null
      },
    },

  };
}
